import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PasswordValidatorService {

  regExp = (/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/);

  constructor() {}

  public passwordFormat = (): ValidatorFn =>
    (control: AbstractControl): { [key: string]: boolean } | null => {
        const value: string = (control.value as string);
        if (value && value !== '') {
          if (!(this.regExp.test(value) && value.length >= 8)) {
            return {format: true};
          }
        }
        return null;
    };

  public matchPasswords = (controlMatchPassword: AbstractControl): ValidatorFn =>
    (control: AbstractControl): { [key: string]: boolean } | null => {
      const value: string = control.value;
      const valueOtherControl: string = controlMatchPassword.value;
      if ((!valueOtherControl || valueOtherControl === '') && (!value || value === '')) {
          return {required: true};
      }
      if (value !== valueOtherControl) {
        return {match: true};
      }
      return null;
    };

}
